export { setupScripts as privacyPreferencesScripts } from "../infra/one-trust/setup-scripts";
